import * as authServices from "./auth.service";
import * as uploadFileServices from "./uploadFile.service";
import * as sysTableServices from "./sysTable.service";

export { authServices, uploadFileServices, sysTableServices };
